import { Directive } from '@angular/core';

@Directive({
  selector: '[unitySidebarTile]',
})
export class SidebarTileDirective {}
